export const environment = {
    production: false,
    baseTitle: 'SNHU',
    environmentMessage: 'Test',
    apiRoot: "https://snhu-test-api.azurewebsites.net/api/v1",
    cdnRoot: "https://snhu-test-api.azurewebsites.net/api/v1",
    useCDN: false,
    tenantKey: '16970b66-9788-4e12-aeb3-36bda56bd32f',
  
    allowConfiguration: true,
    enabledConsoleLogging: true,
    
    googleAnalyticsTrackingToken: null,
    showContactUs: true,
    contactUsEmail: 'support@snhu.com',
    disabledUserInactvityTimeout: false
  };
  